import { PendingComponent } from '@modules/core/components/PendingComponent';
import useFeatureFlags from '@modules/core/hooks/useFeatureFlags';
import { ReactNode } from 'react';
import ProposalCreationLayoutEs from './es';
import ProposalCreationLayoutAe from './ae';

type Props = {
  children?: ReactNode,
};

const ProposalCreationLayout = (_: Props) => {
  const { isFeatureFlagsLoading, isFeatureActive } = useFeatureFlags();
  const isSpain = isFeatureActive('proposals.baytecaMVP');

  if (isFeatureFlagsLoading) {
    return <PendingComponent />;
  }
  if (isSpain) {
    return <ProposalCreationLayoutEs />;
  }
  return <ProposalCreationLayoutAe />;
};

export default ProposalCreationLayout;
